import { useEffect, useState } from 'react'
import {
  FALLBACK_WORKSPACE_TICKETS_SORT_DEFAULTS,
  readCachedWorkspaceTicketsSortDefaults,
  refreshWorkspaceTicketsSortDefaultsFromApi,
  WORKSPACE_TICKETS_SORT_DEFAULTS_CHANGED,
  type WorkspaceTicketsSortDefaults,
} from '@/lib/workspace-tickets-sort-defaults'

export function useWorkspaceTicketsSortDefaults(): WorkspaceTicketsSortDefaults {
  const [defaults, setDefaults] = useState(() => readCachedWorkspaceTicketsSortDefaults())

  useEffect(() => {
    let alive = true
    void refreshWorkspaceTicketsSortDefaultsFromApi()
      .then((next) => {
        if (alive) setDefaults(next)
      })
      .catch(() => {
        if (alive) setDefaults(readCachedWorkspaceTicketsSortDefaults())
      })

    const onChange = () => setDefaults(readCachedWorkspaceTicketsSortDefaults())
    window.addEventListener(WORKSPACE_TICKETS_SORT_DEFAULTS_CHANGED, onChange)
    return () => {
      alive = false
      window.removeEventListener(WORKSPACE_TICKETS_SORT_DEFAULTS_CHANGED, onChange)
    }
  }, [])

  return defaults ?? FALLBACK_WORKSPACE_TICKETS_SORT_DEFAULTS
}
